// assets
import { EnvironmentOutlined } from '@ant-design/icons';

// icons
const icons = { EnvironmentOutlined };

// ==============================|| MENU ITEMS - RUTAS ||============================== //
// Un solo acceso a rutas. La creación se entra por el botón "Crear ruta" de la
// propia pantalla de rutas, no por el menú: tener las dos puertas duplicaba el
// acceso (defecto de la validación de US-002).
//
// El permiso rutas.create sigue aplicándose donde vive ahora la acción: el botón
// de la pantalla está bajo <PermissionGate code="rutas.create"> y la ruta
// /rutas/crear bajo <RequirePermission code="rutas.create">.

const rutas = {
  id: 'group-rutas',
  title: 'Rutas',
  type: 'group',
  children: [{ id: 'rutas', title: 'Rutas', type: 'item', url: '/rutas', icon: icons.EnvironmentOutlined, permission: 'rutas.read' }]
};

export default rutas;
